<app-base-page-template>
  <app-base-page-content-template>
    <app-vendors-grid
      (rowClick)="onRowClicked($event)"
      (addButtonClick)="onAddButtonClicked()">
    </app-vendors-grid>
  </app-base-page-content-template>
</app-base-page-template>
